import React from "react";
import "../styles/testimonial.css";

const testimonials = [
  {
    title: "Reliable Home Care You Can Trust",
    text: "HomoDial provided trained nurses and medical equipment right at our home. The service was smooth, professional, and caring."
  },
  {
    title: "True Human Touch in Healthcare",
    text: "The team treated my parents with respect and warmth. Kuldeep and Jitendra have built a company that truly cares.."
  },
  {
    title: "Professional & Well-Managed Services",
    text: "Clear communication, skilled staff, and excellent coordination HomoDial sets a high standard in home medical care."
  },
  {
    title: "Comfort of Care at Home",
    text: "EHospital-like support without leaving home. The nurses were polite, trained, and compassionate."
  },
  {
    title: "A Company That Understands Families",
    text: "HomoDial doesn’t just provide services they understand emotions and responsibilities towards elders."
  },
  {
    title: "Trusted Name in Home Healthcare",
    text: "We felt confident and stress-free knowing our loved ones were in safe hands."
  },
  {
    title: "Quality Care with Personal Attention",
    text: "Every detail was handled carefully. HomoDial delivers healthcare with professionalism and heart."
  },
  {
    title: "Stress & Anxiety",
    text: "Mental calmness restored with our home with constitutional remedies just true by the HomoDial services."
  }
];

const Testimonial = () => {
  return (
    <section id="testimonials" className="testimonial-section">
      <h2 className="testimonial-title">Our Testimonials</h2>
      <h4 className="testimonial-subtitle">
       Trusted by The Families and Driven by The Care
      </h4>
      <p className="testimonial-desc">
        At HomoDial Healthcare Solution Pvt. Ltd., every service is guided by empathy, professionalism, and a deep sense of responsibility. Under the leadership of Kuldeep Kumar and Jitendra Kumar, we focus on delivering reliable
         home healthcare with a personal, human touch—because every patient deserves care that feels like family.
      </p>

      <div className="testimonial-slider">
        <div className="testimonial-track">
          {[...testimonials, ...testimonials].map((item, index) => (
            <div className="testimonial-box" key={index}>
              <h5>{item.title}</h5>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
